<template>
  <div>
    <Navbar :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar
          active="Rawat Jalan"
          :toReset="(url, stay, noTab) => this.reset(url, stay, noTab)"
        />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid" v-if="loaded">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row mb-5">
            <div class="col-md-12">
              <h5 class="text-uppercase text-info mb-3">
                data pemeriksaan ophthalmic
              </h5>
              <FormRow
                v-for="row in upperForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <hr />
              <h5 class="text-uppercase text-info mt-3"></h5>
              <FormRow
                v-for="row in formKeluhan"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="mb-2" v-if="errorTable">
                <span class="text-danger mb-2"
                  ><i
                    >Data pada tabel ophthalmic di bawah ini kurang lengkap,
                    pastikan sudah terisi semua</i
                  ></span
                >
              </div>
              <TabelOphthalmic @handleChange="handleChange" />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan
                </button>
                <!-- <router-link class="btn btn-outline-danger btn-no-outline float-right text-uppercase" to="/ralan">Batalkan</router-link> -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset(`/ralan/detail/${$route.params.id}`)"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
        <div class="container-fluid" v-else>
          <Loading />
        </div>
        <!-- <div class="block-loading" v-if="blockLoading">
          <Loading />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import TabelOphthalmic from "@/components/TabelOphthalmic.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import Alert from "@/components/Alert.vue";
import Loading from "@/components/Loading.vue";
import {
  setPatientIntro,
  setRawatIntro,
  validateForms,
  resetForms,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  upperForm,
  formKeluhan,
  today,
  time,
} from "@/data/RalanFormOphthalmic.js";

export default {
  name: "RalanFormOphthalmic",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
    TabelOphthalmic,
    Loading,
  },
  data: () => {
    return {
      fromUrl: "",
      blockLoading: true,
      loaded: true,
      plainUrl: "",
      data: data,
      upperForm: upperForm,
      formKeluhan: formKeluhan,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      errorTable: false,
      formSet: {
        no_rawat: "",
        id_petugas: "",
        id_petugas_2: "",
        soap: "",
        foto_fundus: "",
        "foto_usg[0]": "",
        "foto_iol_master[0]": "",
        od_visus_akhir: "",
        os_visus_akhir: "",
        od_ph: "",
        os_ph: "",
        tgl_periksa: today,
        jam_periksa: time,
        keluhan: "",
        od_visus: "",
        od_tio: "",
        od_s_lama: "",
        od_c_lama: "",
        od_x_lama: "",
        od_add_lama: "",
        od_s_kor: "",
        od_c_kor: "",
        od_x_kor: "",
        od_add_kor: "",
        od_catatan: "",
        os_visus: "",
        os_tio: "",
        os_s_lama: "",
        os_c_lama: "",
        os_x_lama: "",
        os_add_lama: "",
        os_s_kor: "",
        os_c_kor: "",
        os_x_kor: "",
        os_add_kor: "",
        os_catatan: "",
      },
      od_visus_l: "",
      od_visus_r: "",
      os_visus_l: "",
      os_visus_r: "",
      saveSuccess: false,
      saveFailed: false,
    };
  },
  computed: {
    od_visus: function() {
      //   this.formSet.od_visus=this.od_visus_l+'/'+this.od_visus_r;
      return this.od_visus_l;
    },
    os_visus: function() {
      //   this.formSet.os_visus=this.os_visus_l+'/'+this.os_visus_r;
      return this.os_visus_l;
    },
    od_visus_akhir: function() {
      return this.od_visus_r;
    },
    os_visus_akhir: function() {
      return this.os_visus_r;
    },
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  watch: {
    $route: function() {
      // Do something when the URL changes
      location.reload();
    },
    od_visus: function(value) {
      this.formSet.od_visus = value;
      //console.log('od_visus:'+this.formSet.od_visus);
    },
    os_visus: function(value) {
      this.formSet.os_visus = value;
      //console.log('os_visus:'+this.formSet.os_visus);
    },
    od_visus_akhir: function(value) {
      this.formSet.od_visus_akhir = value;
    },
    os_visus_akhir: function(value) {
      this.formSet.os_visus_akhir = value;
    },
  },
  methods: {
    reset(url, stay, noTab) {
      // if (this.validated) {
      console.log("[---noTab");
      console.log(noTab);
      console.log("]---noTab");

      resetForms(
        this.formSet,
        [this.upperForm, this.formKeluhan],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      this.loaded = false;
      this.errors = [];
      let formData = new FormData();
      var self = this;
      // let valid = this.validateForm();
      let { forms, validity } = validateForms(
        this.formSet,
        [this.upperForm, this.formKeluhan],
        this,
        true
      );
      let valid = validity;
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (self.formSet[key]) {
            formData.append(key, self.formSet[key]);
          }
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "/ralan/pemeriksaan/ophthalmic",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.reset(`/ralan/detail/${that.$route.params.id}`);
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
      this.loaded = true;
    },
    handleChange(e) {
      //console.log(e.target.name+':'+e.target.value);
      if (
        e.target.name == "od_visus_l" ||
        e.target.name == "od_visus_r" ||
        e.target.name == "os_visus_l" ||
        e.target.name == "os_visus_r"
      ) {
        this[e.target.name] = e.target.value;
      } else {
        if (e.target.type == "file") {
          if (e.target.files && e.target.files.length) {
            this.formSet[e.target.name] = e.target.files[0];
          }
        } else {
          this.formSet[e.target.name] = e.target.value;
        }
      }

      //   if(e.target.name=='tgl_periksa'){
      //     this.upperForm[0].columns[0].value=e.target.value;
      //   }
      //   else if(e.target.name=='jam_periksa'){
      //     this.upperForm[0].columns[1].value=e.target.value;
      //   }
      //   else if(e.target.name=='id_petugas'){
      //     this.upperForm[0].columns[2].value=e.target.value;
      //   }
      //   else if(e.target.name=='keluhan'){
      //     this.formKeluhan[0].columns[0].value=e.target.value;
      //   }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      let forms = [this.upperForm, this.formKeluhan].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              // //console.log(column);
              if (column.regex) {
                //console.log(column.regex);
                if (
                  String(self.formSet[column.name] || "").match(column.regex)
                ) {
                  column.error = "";
                } else {
                  column.error = column.regexError;
                  valid = false;
                }
              } else {
                column.error = "";
              }
            }
            // && self.formSet[column.name]!= self[column.name+'_lama']
            if (self.formSet[column.name]) {
              if (column.type == "file" || column.type == "image") {
                if (self.formSet[column.name]) {
                  var reader = new FileReader();
                  reader.onload = function(e) {
                    column.value = e.target.result;
                  };
                  reader.readAsDataURL(self.formSet[column.name]);
                }
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });

      this.upperForm = forms[0];
      this.formKeluhan = forms[1];

      let oph = this.formSet;
      if (
        !(
          oph["od_visus"] &&
          oph["od_tio"] &&
          oph["od_s_lama"] &&
          oph["od_c_lama"] &&
          oph["od_x_lama"] &&
          oph["od_add_lama"] &&
          oph["od_s_kor"] &&
          oph["od_c_kor"] &&
          oph["od_x_kor"] &&
          oph["od_add_kor"] &&
          oph["os_visus"] &&
          oph["os_tio"] &&
          oph["os_s_lama"] &&
          oph["os_c_lama"] &&
          oph["os_x_lama"] &&
          oph["os_add_lama"] &&
          oph["os_s_kor"] &&
          oph["os_c_kor"] &&
          oph["os_x_kor"] &&
          oph["os_add_kor"]
        )
      ) {
        //console.log(oph["od_visus"]);
        //console.log(oph["os_visus"]);
        valid = false;
        this.errorTable = true;
      } else {
        this.errorTable = false;
      }

      //console.log(self.formSet);
      return valid;
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          this.upperForm[0].columns[2].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
          this.upperForm[0].columns[3].options = this.upperForm[0].columns[2].options;
          this.formSet.id_petugas = this.$store.state.id_petugas || "";
          if (this.formSet.id_petugas) {
            this.upperForm[0].columns[2].value = this.formSet.id_petugas;
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    handlePopstate(event) {
      console.log("going in");
      this.reset(`/ralan/detail/${this.$route.params.id}`, false, true);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      console.log("Selalu Masuk Ke Sini");
      let that = vm;
      setTimeout(function() {
        var myElements = that.$el.querySelectorAll(".upload-image");
        console.log(myElements);
        // loop through each element and change its color
        for (var i = 0; i < myElements.length; i++) {
          myElements[i].style.backgroundImage = "";
          console.log(myElements[i]);
          console.log(myElements[i].style.backgroundImage);
        }
        // vm.blockLoading = false;
      }, 1000);

      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },

  mounted: async function() {
    // this.loaded = true;
    this.data.toReset = (url, stay, noTab) => this.reset(url, stay, noTab);
    this.data.breadcrumb[1].link = `/ralan/detail/${this.$route.params.id}`;
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=0`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        if (result.data.jen_periksa == "Kontrol Lanjutan") {
          this.formKeluhan[2].columns[1].type = "textarea";
        } else {
          this.formKeluhan[2].columns[1].type = "hidden";
        }
        //console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchNurses();
  },

  created() {
    window.addEventListener("popstate", (event) => this.handlePopstate(event));
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", (event) =>
      this.handlePopstate(event)
    );
    next();
  },
};
</script>
